import React from 'react';
import { Pulse, Scale } from '../Pulse/Pulse';
import s from './LoadingView.styles';

export const LoadingView = () => {
  return (
    <s.Wrapper>
      <Pulse visible scale={Scale.FULL} testId="t_loading_view" />
    </s.Wrapper>
  );
};
